import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'reactstrap';

import './InlineEdit.scss';

class InlineEdit extends Component {
  render() {
    let hiddenClass = "";
    if(this.props.hidden) {
      hiddenClass = " hidden";
    }
    return (
      <div className={"inline-edit-container" + hiddenClass} name={(!this.props.hidden ? "inline-edit" : null)}>
        <Form onSubmit={this.props.onClickSave}>
          {this.props.children}
          <div className="close" onClick={this.props.onClickCancel}></div>
          <div className="button-container">
            <Button type="submit" onClick={this.props.onClickSave} color="primary">Save</Button><Button onClick={this.props.onClickCancel}>Cancel</Button>
          </div>
        </Form>
      </div>);
  }
}
InlineEdit.defaultProps= {
  onClickSave: () => {},
  onClickCancel: () => {},
  hidden: true
};

InlineEdit.propTypes = {
  onClickSave: PropTypes.func,
  onClickCancel: PropTypes.func,
  hidden: PropTypes.bool
};

export default InlineEdit;


// WEBPACK FOOTER //
// ./src/components/InlineEdit/InlineEdit.js